<div class="console-page">
  <div class="console-content">
    <app-page-header title="Callback" description="Manejador de URL de retorno para flujos de pago."></app-page-header>
    <p class="console-section__desc">El endpoint de callback está activo.</p>
  </div>
</div>
